module.exports = __webpack_public_path__ + "static/media/escanear_qr.20a72d08.svg";